module.exports = __webpack_public_path__ + "static/media/RaisingChildren_web_1.6212c7eb.jpg";